// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__12VHu","label":"Category_label__26Cuu","content":"Category_content__3B9pp","header":"Category_header__-rweQ","location":"Category_location__h_Yzw"};